import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, DatePicker, Row, Col, Radio, Slider, Checkbox } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

import get from 'lodash/get';
import find from "lodash/find";
import { connect } from 'react-redux';

import { updateUserRequest, createUserRequest } from "../../api/requests";
import { passwordValidationRegex } from "../../utils/passwordValidationRegex";
import {
  getUserCreatePermission,
  getUserUpdatePermission
} from "../../reducers/user/selectors";

import classes from './SettingsUserForm.css';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

const timezones = require('../../utils/timezones.json');

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SettingsUserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showID: false,
      shortTz: get(find(timezones, ({ utc }) => utc.includes(this.props.time_zone)), 'abbr', ''),
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const user = {...values};
          if (user.time_zone === "") {
            user.time_zone = null;
          }

          if (this.props.id) {
            await updateUserRequest(this.props.id , user);
          } else {
            await createUserRequest(user);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  onChangeTimezone = (value) => {
    const shortTz = get(find(timezones, ({ utc }) => utc.includes(value)), 'abbr', '');
    this.props.form.setFieldsValue({'short_tz': shortTz});
  };


  render() {
    const { isLoading, requestResult, showID, shortTz } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { userUpdatePermission, userCreatePermission, id, isNew } = this.props;

    const isEditable = id ? userUpdatePermission : userCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.username} <Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? this.props.i18n.t('Add user') : ''}
          </h4>

          <Row gutter={12}>
            {/*
            <Col span={12}>
              <label>
                <b>Code:</b>
                <Form.Item>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'code', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Code' />
                  )}
                </Form.Item>
              </label>
            </Col>
            */}
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Username')}:</b>
                <Form.Item>
                  {getFieldDecorator('username', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'username', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('User name')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('First name')}:</b>
                <Form.Item>
                  {getFieldDecorator('first_name', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'first_name', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Last name')}:</b>
                <Form.Item>
                  {getFieldDecorator('last_name', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'last_name', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Email')}:</b>
                <Form.Item>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'email', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Phone number')}:</b>
                <Form.Item>
                  {getFieldDecorator('phone_number', {
                    initialValue: get(this.props, 'phone_number', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Time Zone')}:</b>
                <Form.Item>
                  {getFieldDecorator('time_zone', {
                    initialValue: get(this.props, 'time_zone', '')
                  })(
                    <Select showSearch placeholder={this.props.i18n.t('Select')} onChange={this.onChangeTimezone}>
                      <Option value="">{this.props.i18n.t('None')}</Option>
                      {timezones.map(({ utc }) => utc.map((tz, i) => (
                        <Option value={tz} key={i}>{tz}</Option>
                      )))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsUserForm:Short TZ')}</b>
                <Form.Item>
                  {getFieldDecorator('short_tz', {
                    initialValue: shortTz
                  })( <Input disabled={true} type='text' /> )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            {isNew && <Col span={24}>
              <label>
                {getFieldDecorator('send_password_creation_link', {
                  initialValue: get(this.props, 'send_password_creation_link', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:Send password creation link')}</Checkbox>
                )}
              </label>
              <br/>
              <br/>
            </Col>}
            {isNew && <Col span={24}>
              <label>
                {getFieldDecorator('sending_notifications', {
                  initialValue: get(this.props, 'sending_notifications', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:Do not send out welcome and password creation e-mails?')}</Checkbox>
                )}
              </label>
              <br/>
              <br/>
            </Col>}
            <Col span={24}>
              <label>
                {getFieldDecorator('is_2fa_enabled', {
                  initialValue: get(this.props, 'is_2fa_enabled', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:Is 2fa enabled?')}</Checkbox>
                )}
              </label>

              <div className={classes.wrapper2faOptions}>
                <label>
                  {getFieldDecorator('is_2fa_email_enabled', {
                    initialValue: get(this.props, 'is_2fa_email_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:Email 2fa')}</Checkbox>
                  )}
                </label>
                <label>
                  {getFieldDecorator('is_2fa_mobile_app_enabled', {
                    initialValue: get(this.props, 'is_2fa_mobile_app_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:Mobile app 2fa')}</Checkbox>
                  )}
                </label>
                <label>
                  {getFieldDecorator('is_2fa_sms_enabled', {
                    initialValue: get(this.props, 'is_2fa_sms_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>{this.props.i18n.t('NamespaceSettingsUserForm:SMS 2fa')}</Checkbox>
                  )}
                </label>
              </div>
            </Col>
          </Row>


          <Row gutter={12}>
            {!(getFieldValue('send_password_creation_link') && isNew) && <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceSettingsUserForm:Set new password')} {id && this.props.i18n.t('NamespaceSettingsUserForm:(optional)')}</b>
                <Form.Item>
                  {getFieldDecorator('password', {
                    rules: [
                      { required: !id && true, message: this.props.i18n.t('Required') },
                      {
                        pattern: passwordValidationRegex,
                        message: this.props.i18n.t('NamespaceSettingsUserForm:The password must contain at least one UPPERCASE letter, one lowercase letter, one number. Password length between 8-32 characters.')
                      }
                    ]
                  })(
                    <Input type='password' disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>}
            {/*
            get(this.props, 'user_id', '') && <Col span={12}>
              <label>
                <b>Randomization Platform - User ID*</b>

                <Form.Item style={{ position: 'relative' }}>
                  {getFieldDecorator('user_id', {
                    initialValue: get(this.props, 'user_id', ''),
                    rules: [{ required: id && true, message: 'Required' }]
                  })(
                    <Input
                      type={showID ? 'text' : 'password'}
                      disabled
                    />
                  )}

                  <span onClick={() => { this.setState({ showID: !showID }) }} style={{ cursor: 'pointer'}}>
                    {!showID ? <span>Show userID&nbsp;<EyeTwoTone  /></span> : <span>Hide user ID&nbsp;<EyeInvisibleOutlined /></span>}
                  </span>
                </Form.Item>
              </label>
            </Col>
            */}
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userCreatePermission: getUserCreatePermission(state),
  userUpdatePermission: getUserUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'user' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsUserForm)));



// WEBPACK FOOTER //
// ./src/components/SettingsUserForm/SettingsUserForm.js